export const ContactInfoContent = {
  pageTitle: 'Next, provide your contact information',
  useOfResidenceMsg:
    'We use your home address (your primary residence where you live most of the year) for tax-reporting purposes. Updates to this address will apply to other accounts you own.',
  continueButton: 'Continue',
};
